import Alpine from 'alpinejs'

import './helpers'
import './alpine/filter-dropdown-multiselect'
import './alpine/query-tabs'
import './alpine/alpine-select'
import './alpine/activity-log-export-poll'
import './alpine/filter-causer-select'

if (document.getElementById('pipeline-edit-form')) {
    import('./pipeline-editor.js')
} else if (document.getElementById('api-reference')) {
    import('./api-reference.js')
} else if (document.querySelector('.chart-js')) {
    import('./chart-js')
}

window.Alpine = Alpine
window.Alpine.start()

const form = document.getElementById('tenant-selector-form')
if (form) {
    form.addEventListener('submit', function (e) {
        e.preventDefault()
        window.location = document.getElementById('tenant-selector').value
        return false
    })
}

document.querySelectorAll('.js--auto-select-input').
    forEach(function (el) {
        el.addEventListener('click', function () {
            el.setSelectionRange(0, el.value.length)
        })
    })

document.querySelectorAll('.js--set-title-content-on-click[title]').
    forEach(function (el) {
        el.addEventListener('click', function () {
            let text = el.textContent
            el.textContent = el.title
            el.title = text
        })
    })

try {
    const browserTimezone = Intl && Intl.DateTimeFormat
        ? Intl.DateTimeFormat().resolvedOptions().timeZone
        : null
    if (browserTimezone !== null) {
        const recognizedTimezone = document.querySelector(
            'meta[name="recognized-timezone"]',
        ).content
        if (browserTimezone !== recognizedTimezone) {
            document.cookie = 'timezone=' + browserTimezone +
                ';max-age=2592000;path=/;samesite=lax' +
                (document.location.protocol === 'https:' ? ';secure' : '')
        }
    }
}
catch (e) {}

if (window.location.search.includes('push-to-crm=push-to-crm')) {
    history.replaceState(null, null, window.location.search.replace(
        /(&push-to-crm=push-to-crm$|push-to-crm=push-to-crm&)/, ''))
}
